// extracted by mini-css-extract-plugin
module.exports = {"container":"CircleCheckbox_container__3Mfqo","checkbox":"CircleCheckbox_checkbox__23M6d","icon":"CircleCheckbox_icon__1ZaT-","iconDiv":"CircleCheckbox_iconDiv__3tp-X"};